module.exports = __webpack_public_path__ + "static/media/img-open.0279ec1d.png";